import { useContext } from "react";
import { AppointmentsModalProviderContext } from "./appointments-modal-provider.context.js";
const useAppointmentsModalProvider = () => {
  const context = useContext(AppointmentsModalProviderContext);
  if (context === void 0) {
    throw new Error("useAppointmentsModalProvider must be used within a AppointmentsModalProvider");
  }
  return context;
};
export {
  useAppointmentsModalProvider
};
